import { useSelector } from 'react-redux'
import type { RootState } from '@/store'

export function useSliceSelector<
  SliceKey extends keyof RootState,
  FieldKey extends keyof RootState[SliceKey]
>(slice: SliceKey, field: FieldKey) {
  return useSelector((state: RootState) => state[slice][field])
}

/**
 * Select multiple fields from a slice.
 */
export function useMultiSelector<
  SliceKey extends keyof RootState,
  FieldKeys extends readonly (keyof RootState[SliceKey])[]
>(slice: SliceKey, fields: FieldKeys) {
  return useSelector((state: RootState) => {
    const result: any = {}
    fields.forEach((field) => {
      result[field] = state[slice][field]
    })
    return result as Pick<RootState[SliceKey], FieldKeys[number]>
  })
}
